module.exports = __webpack_public_path__ + "files/d42dacc6c02487cda825f7855071b1d0.png";